import React from 'react';
import ReactDOM from 'react-dom/client';
// Theme and Notification providers are handled inside App component
import App from './App';
import './styles/global.css';
import { BrowserRouter } from 'react-router-dom';

// Установка значения API URL по умолчанию
// Устанавливаем VITE_API_URL по умолчанию ТОЛЬКО при локальной разработке
if (
  !import.meta.env.VITE_API_URL &&
  typeof window !== 'undefined' &&
  window.location.hostname === 'localhost'
) {
  (window as unknown as { VITE_API_URL: string }).VITE_API_URL =
    'http://localhost:8001';
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
